import { Component, OnInit } from '@angular/core';
import { ContentfulCacheService } from '../../../services/contentful-cache.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  public notFoundPageIndex = null;

  constructor(public content: ContentfulCacheService) { }

  ngOnInit() {
    this.content.generalPage.transformData.subscribe((transform) => {
      if (transform) {
        this.notFoundPageIndex = this.content.generalPage.data.findIndex(item => item.identifier === '404');
      }
    });
  }

}
